export default {
  path: '/account',
  component: resolve => require(['@/components/common/ViewTemplate'], resolve),
  children: [
    {
      path: '',
      redirect: 'account-detail',
    },
    {
      path: 'account-detail',
      component: resolve => require(['@/components/account/AccountDetail'], resolve),
    },
    {
      path: 'change-phone',
      component: resolve => require(['@/components/account/ChangePhone'], resolve),
    },
    {
      path: 'change-password',
      component: resolve => require(['@/components/account/ChangePassword'], resolve),
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/modules/account/index.js